import {
  FormGroup,
  FormGroupProps,
  useTheme,
  alpha,
  FormControlLabel,
  Stack,
  Typography
} from '@mui/material'
import { ReactElement, ReactNode } from 'react'

export interface AuroraControlProps extends Omit<FormGroupProps, 'children'> {
  label: ReactNode
  value?: ReactNode
  control: ReactElement
  direction?: 'row' | 'column'
  loading?: boolean
  disabled?: boolean
}

export default function AuroraControl({
  direction = 'row',
  loading = false,
  disabled = false,
  label,
  value,
  control,
  sx,
  ...props
}: AuroraControlProps) {
  const theme = useTheme()

  const isColumn = direction === 'column'

  return (
    <FormGroup
      sx={{
        p: 4,
        pr: isColumn ? 4 : 2,
        pb: isColumn ? 6 : 4,
        borderRadius: 2,
        background:
          disabled || loading
            ? alpha(theme.palette.background.default, 0.5)
            : theme.palette.background.default,
        ...sx
      }}
      {...props}
    >
      <FormControlLabel
        value="bottom"
        control={control}
        label={
          value !== undefined ? (
            <Stack
              direction="column"
              alignItems={isColumn ? 'center' : undefined}
              gap={0}
              onClick={(event) => event.preventDefault()}
            >
              <Typography color="text.secondary">{label}</Typography>
              <Typography color="text.primary" fontWeight={500}>
                {value}
              </Typography>
            </Stack>
          ) : (
            <Typography color="text.secondary" onClick={(event) => event.preventDefault()}>
              {label}
            </Typography>
          )
        }
        labelPlacement={isColumn ? 'top' : 'start'}
        sx={{
          display: 'flex',
          alignItems: isColumn ? 'center' : undefined,
          color: 'text.secondary',
          width: '100%',
          m: 0,
          justifyContent: isColumn ? 'center' : 'space-between'
        }}
      />
    </FormGroup>
  )
}
